import { ContentContext } from "../../../../../utils/contexts";

const { withStyles, TablePagination } = window.Material;
import PaginationActions from './PaginationActions';

const styles = {
  pagination: {
    flexGrow: 1,
  },
  toolbar: {
    padding: '0',
    minHeight: '0',
  },
  select: {
    border: '1px solid rgba(0, 0, 0, 0.23) !important',
    borderRadius: '4px !important',
    padding: '0.5rem 1.5rem 0.5rem 0.5rem !important',
  },
  selectIcon: {
    top: 'auto',
    right: '5px',
  },
  selectRoot: {
    margin: '0 0.5rem',
  },
};

class Pagination extends React.PureComponent {
  handleChangeRowsPerPage = event => {
    const { setProperty, fetchContent, searchMode, doSearch, searchQuery } = this.context;

    const pageSize = parseInt(event.target.value, 10);

    setProperty("pageSize", pageSize);
    setProperty("page", 1);

    if (searchMode) {
      doSearch(searchQuery, undefined, 0, pageSize);
    } else {
      fetchContent(undefined, 1, undefined, undefined, pageSize);
    }
  };

  render() {
    const { classes } = this.props;

    const { page, total, pageSize, loadingContent } = this.context;

    return (
      <TablePagination
        count={total}
        page={page - 1}
        onRowsPerPageChange={this.handleChangeRowsPerPage}
        onPageChange={() => {}}
        rowsPerPage={pageSize}
        color="primary"
        labelRowsPerPage={window.Alfresco.messages.global['edocat.pagination.rowsPerPage']}
        classes={{
          root: classes.pagination,
          toolbar: classes.toolbar,
          selectRoot: classes.selectRoot,
        }}
        component="div"
        ActionsComponent={PaginationActions}
        SelectProps={{
          id: 'paginationSelect',
          classes: {
            root: classes.select,
            icon: classes.selectIcon,
          },
          disabled: loadingContent,
        }}
      />
    );
  }
}

Pagination.contextType = ContentContext;

export default withStyles(styles)(Pagination);
